<script setup>
import Words from "@/components/edit/Words.vue";
import Side from "@/components/common/Sidebanner.vue";
import axios  from "axios";
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-sheet>
    <div>
        <v-select
            clearable
            v-model="doc_status"
            :items="statusitem"
            label="状態管理"
            class="pt-2"
        >
        </v-select>
    </div>
        <v-tabs
            v-model="tab"
            fixed-tabs
			background-color="#E13532"
			dark
        >
			<v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab>
                メニュー
            </v-tab>
            <v-tab>
                頻出単語
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-list
               dense>
                <v-list-item
                  v-for="item,index in items"
                  :key="item.title"
                  link
                  @click="menu_link(index)"
                >
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-tab-item>
            <v-tab-item>
                <Words />
            </v-tab-item>
        </v-tabs-items>
  <Side />  
</v-sheet>
</template>
<script>
  export default {
    data () {
      return {
        tab : "",
        statusitem : ["作成中","作成完了","確認中","配信待ち",],
        items: [
          { title: 'AIで作成', icon: 'mdi-robot' },
          { title: 'リリース管理', icon: 'mdi-format-list-bulleted' },
          { title: '保存', icon: 'mdi-content-save-edit-outline' },
          { title: 'ダウンロード', icon: 'mdi-cloud-download-outline' },
          { title: '画像管理'  , icon: 'mdi-image-outline' },
        ],
      }
    },
    computed : {
        doc_id : function(){
            return this.$store.getters['doc_info/get_doc_id'];
        },
        doc_status : {
            get(){
                return this.$store.getters['doc_info/get_docstatus'];
            },
            set(val){
                let set_val = "";
                if(val != null)
                    set_val = val;
                this.$store.commit("doc_info/set_docstatus",set_val);
                if(this.doc_id != "")
                    this.setStatus();
            }
        },
    },
    methods : {
        setStatus : async function(){
            var params = new URLSearchParams();
            params.append("status",this.doc_status);
            params.append("doc_id",this.doc_id);
            axios.post("https://qlipper.jp/api/release/set_status",params)
        },
        menu_link(index){
            this.$emit("menu",{'index':index});
        },
    },
  }
</script>

